import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { cookieHelpers } from 'shared-helpers';

import AmplitudeHelperClass from './utilities/amplitudeHelper';

import MagnittFooter from './micro-frontends/MagnittFooter';
import MagnittHeader from './micro-frontends/MagnittHeader'
import NoMatch from './micro-frontends/NoMatch';
import SideNav from './micro-frontends/SideNav';
import ErrorBoundary from './ErrorBoundary';

import routes from './routes';

import './styles/common.scss';



const amplitudeHelper = new AmplitudeHelperClass();
const cookies = new Cookies();

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userState: props.user
        };
    }

    componentDidMount() {
        const { userState } = this.state;

        setTimeout(function () {
            const user = this.props.user;
            amplitudeHelper.identifyUser(user);
        }.bind(this), 3000)

        this.watchUserCookieChanges();

        if (userState?.is_loggedin) {
            const contentBoxes = document.getElementsByClassName('content-box');
            if (contentBoxes) {
                Array.from(contentBoxes).forEach(element => {
                    if (!element.classList.contains('content-box-logged-in')) {
                        element.classList.add('content-box-logged-in');
                    }
                });
            }
        } else {
            const contentBoxes = document.getElementsByClassName('content-box');
            if (contentBoxes) {
                Array.from(contentBoxes).forEach(element => {
                    if (element.classList.contains('content-box-logged-in')) {
                        element.classList.remove('content-box-logged-in');
                    }
                });
            }
        }
    }

    /**
	 * watch for user cookie changes from shared
	 * then compare to react/content cookie & if there's a mismatch, update view
	 */
    watchUserCookieChanges = () => {
        const { userState } = this.state;
        cookieHelpers.watchCookieChanges(userState, this);
    }

    render() {

        const { userState } = this.state;
        const { history } = this.props;

        return (
            <div className="App">

                <SideNav userState={userState} />

                <div className={`main-content ${userState?.is_loggedin ? 'main-content-logged-in' : ''}`} id="panel">

                    <MagnittHeader history={history} data={{ app: 'content' }} userState={userState} />

                    <div id='content' className='content-container'>

                        <ErrorBoundary>
                            <Switch>

                                {routes.map(({ path, exact, component: Component, ...props }) => (
                                    <Route
                                        key={path}
                                        path={path}
                                        exact={exact}
                                        render={routeProps => (
                                            <Component {...routeProps} {...props} />
                                        )}
                                    />
                                ))}

                                <Redirect exact from="/" to="/news" />

                                {/* fix for double slashes user typo */}
                                <Redirect from="*//*" to="*/*" />

                                {/*<Route component={NoMatch} />*/}
                                <Route render={(props) => <NoMatch {...props} />} />

                            </Switch>
                        </ErrorBoundary>
                        <MagnittFooter />
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state) => ({
    user: state.userReducer
});

export default withRouter(connect(mapStateToProps, {})(App));
